import { DateInput } from '@components/index';
import { memo } from 'react';
import { BigInputDiv, InputList } from '../styles';
import { PropsInputSingle, FlattenSingle } from './types';
import { onChangeSingle } from './utils';

type OwnershipSingleProps = PropsInputSingle &
  FlattenSingle<'installDate' | 'purchasedDate'>;
function OwnershipSingle(props: OwnershipSingleProps) {
  const { installDate, purchasedDate, setFormV, index, onlyGroupEdits } = props;
  const installDateName = `equipments.${index}.installDate` as const;
  const purchasedDateName = `equipments.${index}.purchasedDate` as const;

  return (
    <InputList>
      <BigInputDiv>
        <DateInput
          value={installDate}
          handleDateChange={e => {
            let convDate: Date | null = null;
            if (e) convDate = new Date(e);
            onChangeSingle(installDateName, convDate, setFormV);
          }}
          disabled={onlyGroupEdits}
        />
      </BigInputDiv>
      <BigInputDiv>
        {/* Note: This is the same field as purchasedDate in purchase information */}
        <DateInput
          value={purchasedDate}
          handleDateChange={e => {
            let convDate: Date | null = null;
            if (e) convDate = new Date(e);
            onChangeSingle(purchasedDateName, convDate, setFormV);
          }}
          disabled={onlyGroupEdits}
        />
      </BigInputDiv>
    </InputList>
  );
}
export default memo(OwnershipSingle);
